import actionTypes from '../actions/manage-icons.actions';

const initialState = {
  entries: [],
  entriesDeleted: [],
  isLoading: false,
  iconsApprovalStatus: null,
  error: '',
  notification: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ICONS_REQUEST:
    case actionTypes.FETCH_ICONS_FAILURE:
    case actionTypes.DISCARD_CHANGES_FAILURE:
    case actionTypes.DISCARD_CHANGES_REQUEST:
      return {
        ...state,
        isLoading: action.isLoading,
      };
    case actionTypes.DISCARD_CHANGES_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        notification: action.notification,
      };
    case actionTypes.FETCH_ICONS_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        entries: [...action.entries],
        iconsApprovalStatus: action.versionType,
      };
    case actionTypes.UPLOAD_ICON_REQUEST:
    case actionTypes.UPLOAD_ICON_FAILURE:
      return {
        ...state,
        isFileUploading: action.isFileUploading,
      };
    case actionTypes.UPLOAD_ICON_SUCCESS:
      return {
        ...state,
        isFileUploading: action.isFileUploading,
        notification: action.notification,
        iconsApprovalStatus: action.iconsApprovalStatus,
      };
    case actionTypes.SELECT_ICON_REQUEST: {
      return {
        ...state,
        startFileSelection: action.startFileSelection,
      };
    }
    case actionTypes.SELECT_ICON_FAILURE:
      return {
        ...state,
        startFileSelection: action.startFileSelection,
        error: action.error,
      };
    case actionTypes.SELECT_ICON_SUCCESS:
      return {
        ...state,
        startFileSelection: action.startFileSelection,
        notification: action.notification,
        entries: [...[action.icon], ...state.entries],
      };

    case actionTypes.DELETE_ICON:
      return {
        ...state,
        notification: action.notification,
        entries: state.entries.filter((icon) => icon !== action.icon),
        entriesDeleted: [...[action.icon], ...state.entriesDeleted],
      };
    case actionTypes.CANCEL_CHANGES:
      return {
        ...state,
        entries: [
          ...state.entries.filter((icon) => icon.id !== undefined),
          ...state.entriesDeleted,
        ],
        entriesDeleted: initialState.entriesDeleted,
      };
    case actionTypes.CLEAR_NOTIFICATIONS:
      return {
        ...state,
        error: action.error,
        notification: action.notification,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/reducers/manage-icons.reducer.js